import { AttributesSelector, Box, Flex, Input, Text } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { FiltersSchema } from './filtersSchema'

const CompletedDaysAgoInputs = () => {
  const { register } = useFormContext<FiltersSchema>()

  return (
    <Box>
      <Flex flexDirection="column" gap={2}>
        <Box>
          <Text fontSize="sm" fontWeight="medium" mb={1}>
            Days Since Completion
          </Text>
          <Input
            type="number"
            placeholder="2"
            min={1}
            {...register('completedDaysAgo.days', {
              setValueAs: (value) => (value ? parseInt(value, 10) : null),
            })}
          />
          <Text fontSize="xs" color="lightText" mt={1}>
            Show shifts completed more than this many days ago
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}

export const CompletedDaysAgoFilters = () => {
  const methods = useFormContext<FiltersSchema>()

  const days = methods.watch('completedDaysAgo.days')

  const resetToDefaultValues = () => {
    methods.setValue('completedDaysAgo.days', null)
  }

  const selectedAttributes = useMemo(() => {
    const attributes: string[] = []

    if (days) {
      attributes.push(`${days} days ago`)
    }

    return attributes
  }, [days])

  return (
    <FormProvider {...methods}>
      <AttributesSelector
        label="Completed"
        rootGroupTitle="Filter by"
        selectedAttributes={selectedAttributes}
        onClearAll={resetToDefaultValues}
        groups={
          <AttributesSelector.Group
            key="completedDaysAgo"
            title="Completed"
            numberOfSelectedAttributes={selectedAttributes.length}
          >
            <CompletedDaysAgoInputs />
          </AttributesSelector.Group>
        }
      />
    </FormProvider>
  )
}
